import { formatDistanceToNow } from 'date-fns';
import { connect } from 'react-redux';
import { IonList, IonIcon, IonItem, IonSelect, IonSelectOption, IonLabel, IonNote, IonText } from '@ionic/react';
import { add as iconAdd } from 'ionicons/icons';

import { presentAsLine } from 'lib/text';
import { projectsSelector, SORT_OPTIONS, sortedProjects } from 'selectors/projectSelector';
import ProjectActions from 'actions/ProjectActions';
import ProjectsLayout from 'components/layouts/Projects';

function mapStateToProps(state) {
  return {
    projectList: projectsSelector(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getProjects: () => dispatch(ProjectActions.getProjects()),
  }
}

function withReduxConnect(Component) {
  return connect(mapStateToProps, mapDispatchToProps)(Component);
}

class ProjectList extends React.Component {
  state = {
    sortOrder: _.first(SORT_OPTIONS),
    errorMsg: ''
  }

  componentDidMount() {
    this.fetchProjects();
  }

  fetchProjects = (e) => {
    this.props.getProjects().then((projects) => {
      if (projects?.errors) {
        console.warn(projects.errors);
        this.setState({errorMsg: projects?.errors?.error});
      }
    }).catch((error) => {
      console.warn('Error fetching projects:', error);
      this.setState({errorMsg: error.toString()});
    }).finally(() => {
      e?.detail.complete()
    });
  }

  updateSortOrder = (event) => {
    this.setState({sortOrder: event.detail.value});
  }

  render() {
    const {sortOrder, errorMsg} = this.state;
    const {projectList} = this.props;

    return (
      <ProjectsLayout>
        <IonList lines="full">
          {errorMsg && <IonItem color="danger">{errorMsg}</IonItem>}
          <IonItem>
            <IonLabel>Sort by:</IonLabel>
            <IonSelect onIonChange={this.updateSortOrder} value={sortOrder} interface="popover">
              {_.map(SORT_OPTIONS, (option) => (
                <IonSelectOption key={option} value={option}>{option}</IonSelectOption>
              ))}
            </IonSelect>
          </IonItem>
          <IonItem color="light" routerLink="/projects/new" detail="false">
            <IonIcon icon={iconAdd} size="large" color="primary"/>
            <IonLabel color="primary"><strong>New Project</strong></IonLabel>
          </IonItem>

          {sortedProjects(projectList, sortOrder).map(({id, name, client, city, state, updated_at, errors}) => (
            <IonItem key={id} routerLink={`/projects/${id}`}>
              <IonLabel>
                <p>
                  {name}
                </p>
                <p>
                  {presentAsLine(
                    client,
                    _.join(_.compact([city, state]), ", ")
                  )}
                </p>
                {errors && <IonText color="danger">Unable to save project: {errors}</IonText>}
              </IonLabel>
              <IonNote>{updated_at && formatDistanceToNow(updated_at) + ' ago'}</IonNote>
            </IonItem>
          ))}
        </IonList>
      </ProjectsLayout>
    );
  }
};

export default withReduxConnect(ProjectList);
